/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingResourcesRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingResourcesRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingResourcesRequest>): AwsSecurityHubFindingResourcesRequest {
        let obj = Object.assign(new AwsSecurityHubFindingResourcesRequest(), model);
        AwsSecurityHubFindingResourcesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingResourcesRequest>): AwsSecurityHubFindingResourcesRequest {
        if (!model) return null;
        return AwsSecurityHubFindingResourcesRequest.newInstance(<AwsSecurityHubFindingResourcesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingResourcesRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingResourcesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingResourcesRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingResourcesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which tenant Id to fetch regions for
     */
    tenant_id: string;

}
